module.exports = __webpack_public_path__ + "img/BestEmployee.4c6c8248.svg";